const displayRoutes = [
    {
        path: '/display',
        name: 'Display',
        component: () => import('@/views/Display'),
        meta: {requiresAuth: false},
    },
    {
        path: '/display-club',
        name: 'DisplayClub',
        component: () => import('@/views/Display/ProvinceIndex'),
        meta: {requiresAuth: false},
    },
];

export  default displayRoutes;
